module.exports = __webpack_public_path__ + "img/impiantoarancione.dee6eefe.png";